var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyContactDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkbox-checked-svgrepo-com",
    d: "M6.75,0A6.786,6.786,0,0,0,0,6.75v22.5A6.786,6.786,0,0,0,6.75,36h22.5A6.786,6.786,0,0,0,36,29.25V6.75A6.786,6.786,0,0,0,29.25,0Zm0,4.5h22.5a2.2,2.2,0,0,1,2.065,1.318l-1.5,1.705L15.645,23.713l-5.054-5.054a2.253,2.253,0,1,0-3.182,3.19l6.75,6.75a2.255,2.255,0,0,0,3.287-.114L31.5,12.428V29.25a2.2,2.2,0,0,1-2.25,2.25H6.75A2.2,2.2,0,0,1,4.5,29.25V6.75A2.2,2.2,0,0,1,6.75,4.5Zm0,0",
    fill: "#081831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyContactDetailsIcon);
export default __webpack_public_path__ + "static/media/verifyContactDetailsIcon.dd9754fb57bed8d28ecb9068bafa56b9.svg";
export { ForwardRef as ReactComponent };